<!-- /src/components/common/List/Listing.vue -->
<template>
  <div>
    <div v-if="listing.length > 0" class="listing">
      <ul class="listing__items">
        <li v-for="(item, index) in listing" :key="index">
          <DownloadListing
            v-if="item.post_type == 'downloadable_file'"
            :post="item" :type="item.post_type"
          />
          <List v-else :post="item" :removeElements="removeElements" />

        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import List from '@/components/common/List/ListStyle'
import DownloadListing from '@/components/common/List/DownloadListing'

export default {
  data() {
    return {
      noCards: false,
    }
  },
  props: {
    listing: {
      type: [Array, Object],
      required: true,
    },
    removeElements: {
      type: [Array, Object],
      required: false,
    },
  },
  components: {
    List,
    DownloadListing,
  },
}
</script>

<style scoped>

.listing {
  margin-bottom: 3rem;

  &__items {

    /* @media (--desktop-large) {
      grid-gap: var(--itemSpacing-lg);
    } */
  }

  li {
    &> div {
        background-color: white;
    }

    &:first-child {
        &> div {
          border-radius: 4px 4px 0 0; 
        }
    }

    &:last-child {
        &> div {
          border-radius: 0 0 4px 4px; 
        }
    }

    &:nth-child(odd) {
      &> div {
        background-color: #f7f8f9;
      }
    }
  }
}

.loader {
  text-align: center;
  margin-top: 4rem;
  margin-bottom: 4rem;
}
</style>
